import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AppComponent } from './app.component';
import { LoginComponent } from './Login/login.component';
import { HomeComponent } from './Home/home.component';

// core components
import { ForgotPasswordComponent } from './Forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './Reset-password/reset-password.component';
import { SetPasswordComponent } from './Set-password/set-password.component';
import { UnauthorisedComponent } from './unauthorised/unauthorised.component';

import { NgxPermissionsGuard } from 'ngx-permissions';
import { AuthGuard } from './_guards/auth.guard';
import { QrLandingPageComponent } from './QR-code/components/qr-landing-page/qr-landing-page.component';

//Audit Servey components
// import { AuditSurveyListComponent } from './Vehicle-check/components/AuditSurvey/list/audit-survey-list.component';
// import { AuditSurveyDetailComponent } from './Vehicle-check/components/AuditSurvey/detail/audit-survey-detail.component';
// import { AuditSurveyReportComponent } from './Vehicle-check/components/AuditSurvey/report/report.component';
// import { ItemReportComponent } from './components/AuditSurvey/item-report/item-report.component';
// import { AddAuditSurveyComponent } from './components/AuditSurvey/modals/AddAuditSurvey/add-audit-survey.component';
// import { ItemBuilderComponent } from "./components/AuditSurvey/item-builder/item-builder.component";
// import { ItemPreviewComponent } from "./components/AuditSurvey/item-preview/item-preview.component";

// service
// import { AuditSurveyService } from "./_services/audit-survey.service";

// dialogs
// import { AuditSurveyReportCreateComponent } from "./Vehicle-check/components/AuditSurvey/report/create/audit-survey-report-create.component";

const appRoutes: Routes = [
  // lazy loading modules
  {
    path: 'administration',
    loadChildren: './Administration/administration.module#AdministrationModule'
  },
  {
    path: 'vehiclecheck',
    loadChildren: './Vehicle-check/vehicle-check.module#VehicleCheckModule'
  },
  {
    path: 'audit_survey',
    loadChildren: './Vehicle-check/vehicle-check.module#VehicleCheckModule'
  },
  {
    path: 'help',
    loadChildren: './QR-code/qr-code.module#QrCodeModule'
  },
  {
    path: 'safety',
    loadChildren: './QR-code/qr-code.module#QrCodeModule'
  },
  {
    path: 'telematics',
    loadChildren: './Telematics/telematics.module#TelematicsModule'
  },
  {
    path: 'events',
    loadChildren: './Events/events.module#EventsModule'
  },
  {
    path: 'vehicle-file',
    loadChildren: './Vehicle-file/vehicle-file.module#VehicleFileModule'
  },
  {
    path: 'vor-dashboard',
    loadChildren: './Vor-dashboard/vor-dashboard.module#VORDashboardModule'
  },
  {
    path: 'video',
    loadChildren: './Video/video.module#VideoModule'
  },
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'home',
    component: HomeComponent,
    //canActivate: [AuthGuard]
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        except: ['GUEST'],
        redirectTo: '/login'
      }
    }
  },
  {
    // This is used for QR Code actions landing page
    path: 'qr',
    component: QrLandingPageComponent
    // redirectTo: '/help/qr',
    // pathMatch: 'full'
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'reset_password_key',
    component: ResetPasswordComponent
  },
  {
    path: 'set_password',
    component: SetPasswordComponent
  },
  {
    path: 'unauthorised',
    component: UnauthorisedComponent
  },

  {
    path: '**',
    redirectTo: '/home',
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: '**',
    redirectTo: '/login',
    pathMatch: 'full',
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class AppRoutingModule { }
export const routingComponents = [
  AppComponent,
  LoginComponent,
  HomeComponent
];



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/app.routes.ts